import { TransportCategory } from 'src/app/trip-calculator/models/transport';
import { AlternativeMode } from '../models/reduction-tip';

/** Lucide icon of each ground alternative, on the page rows and in the routes dialog. */
export const ALTERNATIVE_ICON: Record<AlternativeMode, string> = {
  train: 'tram-front',
  bus: 'bus',
  ferry: 'ship',
  mixed: 'route',
  carpooling: 'car',
};

/**
 * Lucide icon of a vehicle on a confirmed itinerary, by transport category —
 * a leg is a `highspeedTrain` or a `coachBus`, never an alternative mode.
 */
export const VEHICLE_CATEGORY_ICON: Partial<Record<TransportCategory, string>> =
  {
    [TransportCategory.Train]: 'tram-front',
    [TransportCategory.Bus]: 'bus',
    [TransportCategory.Car]: 'car',
    [TransportCategory.Boat]: 'ship',
  };
